import { render } from "./shopCount.vue?vue&type=template&id=5c48e00d&scoped=true"
import script from "./shopCount.vue?vue&type=script&lang=js"
export * from "./shopCount.vue?vue&type=script&lang=js"

import "./shopCount.vue?vue&type=style&index=0&id=5c48e00d&scoped=true&lang=less"

import exportComponent from "D:\\web\\my\\水茶花\\sch-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c48e00d"]])

export default __exports__